var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{staticClass:"logo-loading",attrs:{"src":_vm.loadingImage,"alt":"loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }